import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { UserService } from "@app/services/user.service";
import { Observable, from, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: "root", // Ensures the service is a singleton and tree-shakable
})
export class ExpirationGuardService {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return from(this.userService.hasExpired()).pipe(
      map((hasExpired) => {
        if (hasExpired) {
          window.location.href = "/auth/redirect-to-foldsquare?next=/pricing";
          return false;
        }
        return true;
      }),
      // Fail closed: if the expiration lookup errors we cannot know the user's
      // state, so send them back to the login entry point rather than leaving
      // the navigation unresolved on a blank page.
      catchError((error) => {
        console.error("ExpirationGuardService: expiration check failed", error);
        this.router.navigate(["/"]);
        return of(false);
      })
    );
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
